var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary" },
            on: {
              click: function($event) {
                _vm.setGoodsCat()
              }
            }
          },
          [_vm._v("关联商品分类")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.devcGoodsCatRelList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "devcCatFullName",
                label: "资产分类全名称",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "goodsCatFullName",
                label: "商品分类全名称",
                align: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "creatorName",
                label: "创建人",
                align: "left",
                width: "160"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "createTime",
                label: "创建时间",
                align: "center",
                width: "180"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", align: "left", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.deleteRow(rows.row.id)
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-layout mt10" },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            "page-size": _vm.pageSize,
            "page-sizes": _vm.pageSizes,
            "current-page": _vm.pageNumber,
            total: _vm.totalCount,
            layout: "prev, pager, next, jumper, sizes, total"
          },
          on: {
            "current-change": _vm.handlePageChange,
            "size-change": _vm.handleSizeChange
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d205a13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d205a13","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/categ/DevcGoodsCatRelList.vue
// module id = 2486
// module chunks = 0